/* EVParto category tree.  06-09.

   WHAT IT DOES
   A click on a branch of the tree swaps the grid instead of reloading the page.
   The address bar still changes, the back button still works, and with
   JavaScript off or broken every link is an ordinary link that navigates.

   WHY NOT AN IN-PAGE FILTER WITH NO URL
   The biggest car in the catalogue carries 1,135 parts. Holding all of them in
   the page to filter client-side is slow on a phone and throws away paging. And
   a filter that never changes the address gives a buyer nothing to bookmark or
   send to his mechanic, and gives a search engine nothing at all.

   WHY NOT A PLAIN RELOAD
   It works, and it is what this shipped as first, but a tree is clicked four or
   five times in a row while somebody hunts for a part. Four full page loads to
   find one bracket is the difference between browsing and giving up.

   HOW
   Shopify renders any section on its own at <url>?section_id=<id>, so the click
   fetches the same URL it would have navigated to, takes the section's HTML and
   swaps it in whole. Whole, not in pieces: the server has already worked out
   which branch is open, which row is current, what the heading says and what is
   in the grid, so taking all of it keeps those four things in step. Rebuilding
   them in JavaScript is how a tree ends up highlighting one category while
   showing another.

   EVERY FAILURE FALLS BACK TO NAVIGATING. No fetch, a bad response, a missing
   element: location.href, and the buyer gets the page the old way. A broken
   catalogue navigator is worse than a slow one.
*/
(function () {
  'use strict';

  var ROOT = '[data-evp-tree]';

  function sectionOf(el) {
    var s = el.closest('[id^="shopify-section-"]');
    return s ? { el: s, id: s.id.replace('shopify-section-', '') } : null;
  }

  function supported() {
    return window.fetch && window.history && window.history.pushState &&
           window.DOMParser && Element.prototype.closest;
  }

  /* The expand-all button and the tree links are both inside the markup that
     gets replaced, so nothing may be bound to them directly. Everything is
     delegated from the document and survives every swap. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.ctall');
    if (btn) {
      var open = btn.dataset.state !== 'open';
      document.querySelectorAll('.cattree .cgrp').forEach(function (d) { d.open = open; });
      btn.dataset.state = open ? 'open' : 'closed';
      btn.textContent = open ? 'Collapse all' : 'Expand all';
      return;
    }

    if (!supported()) return;
    var a = e.target.closest(ROOT + ' .ctree a, ' + ROOT + ' .pgnav a');
    if (!a) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
    if (a.target === '_blank' || a.hasAttribute('download')) return;
    if (a.origin !== window.location.origin) return;
    e.preventDefault();
    go(a.href, true);
  });

  window.addEventListener('popstate', function () {
    if (supported() && document.querySelector(ROOT)) go(window.location.href, false);
  });

  var inflight = null;

  function go(url, push) {
    var root = document.querySelector(ROOT);
    if (!root) { window.location.href = url; return; }
    var sec = sectionOf(root);
    if (!sec) { window.location.href = url; return; }

    if (inflight) { inflight.abort(); }
    var ctrl = window.AbortController ? new AbortController() : null;
    inflight = ctrl;

    root.setAttribute('aria-busy', 'true');

    var sep = url.indexOf('?') > -1 ? '&' : '?';
    fetch(url + sep + 'section_id=' + encodeURIComponent(sec.id),
          ctrl ? { signal: ctrl.signal } : undefined)
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[id^="shopify-section-"]') || doc.body;
        if (!fresh || !fresh.querySelector(ROOT)) throw new Error('no tree in response');

        sec.el.innerHTML = fresh.innerHTML;

        /* The section fetch carries no <head>, so the tab title is taken from
           the heading the server just rendered rather than composed here. */
        var h1 = sec.el.querySelector('h1');
        if (h1 && h1.textContent.trim()) {
          document.title = h1.textContent.trim() + ' | EVParto';
        }

        if (push) window.history.pushState({ evpTree: 1 }, '', url);

        var band = sec.el.querySelector('.band') || sec.el;
        var y = band.getBoundingClientRect().top + window.pageYOffset - 12;
        if (window.pageYOffset > y) window.scrollTo({ top: y, behavior: 'smooth' });

        var cur = sec.el.querySelector('.cattree a.on');
        if (cur) cur.scrollIntoView({ block: 'nearest' });
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        window.location.href = url;
      })
      .then(function () {
        var r = document.querySelector(ROOT);
        if (r) r.removeAttribute('aria-busy');
        inflight = null;
      });
  }
})();
